import React from "react";
import { Link } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Table from "react-bootstrap/Table";
import Layout from "../Components/Layout/Layout";
import Dropdown from "react-bootstrap/Dropdown";
import Pagination from "react-bootstrap/Pagination";
import { useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
export default function EventsDetails() {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <Layout>
      <Container fluid>
        <Row>
          <Col lg={12}>
            <div className="comn-table-title mb-3">
              <h3></h3>
              <button onClick={handleShow}>Create Event</button>
            </div>
          </Col>
          <Col lg={12}>
            <div className="detail-view-card">
              <div className="detail-pro-img">
                <img src={require("../../src/Assets/Images/user.png")} />
              </div>
              <div className="detail-pro-name">
                <h2>Jordan Stevenson</h2>
                <p>Sunday, Dec 01,2024</p>
                <p>9 am - 12 pm</p>
              </div>
              <div className="detail-pro-edition">
                <p>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="19"
                    viewBox="0 0 18 19"
                    fill="none"
                  >
                    <g clip-path="url(#clip0_114_6746)">
                      <path
                        d="M8.99903 5C8.40568 5 7.82566 5.17595 7.33231 5.50559C6.83897 5.83524 6.45445 6.30377 6.22739 6.85195C6.00032 7.40013 5.94091 8.00333 6.05667 8.58527C6.17242 9.16721 6.45815 9.70176 6.8777 10.1213C7.29726 10.5409 7.83181 10.8266 8.41375 10.9424C8.9957 11.0581 9.5989 10.9987 10.1471 10.7716C10.6953 10.5446 11.1638 10.1601 11.4934 9.66671C11.8231 9.17336 11.999 8.59334 11.999 8C11.999 7.20435 11.683 6.44129 11.1203 5.87868C10.5577 5.31607 9.79468 5 8.99903 5ZM8.99903 9.5C8.70235 9.5 8.41234 9.41203 8.16567 9.2472C7.919 9.08238 7.72674 8.84811 7.61321 8.57403C7.49967 8.29994 7.46997 7.99834 7.52785 7.70736C7.58572 7.41639 7.72859 7.14912 7.93837 6.93934C8.14814 6.72956 8.41542 6.5867 8.70639 6.52882C8.99736 6.47094 9.29896 6.50065 9.57305 6.61418C9.84714 6.72771 10.0814 6.91997 10.2462 7.16665C10.4111 7.41332 10.499 7.70333 10.499 8C10.499 8.39783 10.341 8.77936 10.0597 9.06066C9.77838 9.34196 9.39685 9.5 8.99903 9.5Z"
                        fill="#979699"
                      />
                      <path
                        d="M8.99926 18.5C8.36772 18.5033 7.74459 18.3551 7.18206 18.0681C6.61952 17.781 6.13396 17.3633 5.76601 16.85C2.90776 12.9073 1.45801 9.94328 1.45801 8.03979C1.45801 6.03972 2.25253 4.12157 3.66679 2.70732C5.08105 1.29306 6.99919 0.498535 8.99926 0.498535C10.9993 0.498535 12.9175 1.29306 14.3317 2.70732C15.746 4.12157 16.5405 6.03972 16.5405 8.03979C16.5405 9.94328 15.0908 12.9073 12.2325 16.85C11.8646 17.3633 11.379 17.781 10.8165 18.0681C10.2539 18.3551 9.6308 18.5033 8.99926 18.5ZM8.99926 2.13579C7.43357 2.13757 5.93252 2.76033 4.82541 3.86744C3.7183 4.97455 3.09554 6.4756 3.09376 8.04129C3.09376 9.54879 4.51351 12.3365 7.09051 15.8908C7.30928 16.1921 7.59629 16.4374 7.92804 16.6065C8.2598 16.7756 8.62688 16.8638 8.99926 16.8638C9.37163 16.8638 9.73872 16.7756 10.0705 16.6065C10.4022 16.4374 10.6892 16.1921 10.908 15.8908C13.485 12.3365 14.9048 9.54879 14.9048 8.04129C14.903 6.4756 14.2802 4.97455 13.1731 3.86744C12.066 2.76033 10.5649 2.13757 8.99926 2.13579Z"
                        fill="#979699"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_114_6746">
                        <rect
                          width="18"
                          height="18"
                          fill="white"
                          transform="translate(0 0.5)"
                        />
                      </clipPath>
                    </defs>
                  </svg>{" "}
                  Location: <span>Leicester</span>
                </p>
                <p>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="19"
                    viewBox="0 0 18 19"
                    fill="none"
                  >
                    <g clip-path="url(#clip0_114_6753)">
                      <path
                        d="M17.7583 1.80284C17.828 1.73321 17.8832 1.65054 17.9209 1.55956C17.9586 1.46858 17.978 1.37107 17.978 1.27259C17.978 1.17412 17.9586 1.0766 17.9209 0.985623C17.8832 0.894642 17.828 0.811975 17.7583 0.742342C17.6887 0.672708 17.606 0.617472 17.5151 0.579787C17.4241 0.542101 17.3266 0.522705 17.2281 0.522705C17.1296 0.522705 17.0321 0.542101 16.9411 0.579787C16.8501 0.617472 16.7675 0.672708 16.6978 0.742342L12.9298 4.51034C12.062 3.86411 11.0111 3.51083 9.92916 3.50166C8.84723 3.49249 7.79045 3.82791 6.91183 4.45934C6.63541 4.6466 6.4117 4.90169 6.26212 5.20018C6.11255 5.49868 6.04212 5.83058 6.05758 6.16409C6.08758 6.71009 5.77333 7.18409 5.12533 7.57334C4.49683 7.95059 3.92308 8.04659 3.42433 7.86209C3.02295 7.71365 2.58388 7.70137 2.17483 7.82715C1.76578 7.95293 1.40947 8.20978 1.16083 8.55809C0.296531 9.76916 -0.109462 11.2479 0.0152685 12.7305C0.139999 14.2131 0.78734 15.6032 1.84183 16.6528C2.89109 17.7076 4.28098 18.3553 5.76351 18.4803C7.24604 18.6053 8.72476 18.1995 9.93583 17.3353C10.285 17.0869 10.5425 16.7302 10.6683 16.3206C10.7942 15.9109 10.7813 15.4712 10.6318 15.0696C10.4451 14.5686 10.5411 13.9948 10.9183 13.3671C11.3076 12.7191 11.7951 12.4033 12.3291 12.4371C12.6633 12.4548 12.9963 12.3854 13.2956 12.2358C13.595 12.0862 13.8504 11.8615 14.0368 11.5836C14.6675 10.7059 15.0027 9.65038 14.994 8.56963C14.9852 7.48888 14.6329 6.43892 13.9881 5.57159L17.7576 1.80209L17.7583 1.80284ZM12.7986 10.7398C12.7557 10.802 12.6983 10.8527 12.6314 10.8876C12.5645 10.9225 12.4901 10.9405 12.4146 10.9401C11.7651 10.9033 10.5486 11.0698 9.63283 12.5961C8.85658 13.8906 8.98408 14.9413 9.22708 15.5946C9.26179 15.6864 9.26509 15.7872 9.23646 15.8811C9.20783 15.975 9.14888 16.0568 9.06883 16.1136C8.25207 16.6949 7.27302 17.0044 6.27051 16.9981C5.26801 16.9917 4.29294 16.6699 3.48358 16.0783L4.28083 15.2811C4.35047 15.2115 4.4057 15.1288 4.44339 15.0378C4.48107 14.9468 4.50047 14.8493 4.50047 14.7508C4.50047 14.6524 4.48107 14.5549 4.44339 14.4639C4.4057 14.3729 4.35047 14.2902 4.28083 14.2206C4.2112 14.151 4.12853 14.0957 4.03755 14.058C3.94657 14.0204 3.84906 14.001 3.75058 14.001C3.65211 14.001 3.55459 14.0204 3.46361 14.058C3.37263 14.0957 3.28997 14.151 3.22033 14.2206L2.42233 15.0186C1.82875 14.2089 1.50561 13.2326 1.49888 12.2287C1.49215 11.2247 1.80216 10.2442 2.38483 9.42659C2.44174 9.34684 2.52342 9.28815 2.61716 9.25966C2.7109 9.23117 2.81142 9.23449 2.90308 9.26909C3.55408 9.51134 4.60333 9.63659 5.89708 8.86034C7.42183 7.94459 7.59058 6.72659 7.55458 6.08234C7.54708 5.93609 7.62358 5.78909 7.78408 5.67959C8.37412 5.25496 9.07873 5.01857 9.80548 5.00144C10.5322 4.98431 11.2472 5.18723 11.8566 5.58359L7.72033 9.71984C7.6507 9.78948 7.59546 9.87214 7.55778 9.96312C7.52009 10.0541 7.5007 10.1516 7.5007 10.2501C7.50069 10.3486 7.52009 10.4461 7.55778 10.5371C7.59546 10.628 7.6507 10.7107 7.72033 10.7803C7.78997 10.85 7.87263 10.9052 7.96361 10.9429C8.05459 10.9806 8.15211 11 8.25058 11C8.34906 11 8.44657 10.9806 8.53755 10.9429C8.62853 10.9052 8.7112 10.85 8.78083 10.7803L12.9148 6.64634C13.7068 7.86959 13.6986 9.47909 12.7986 10.7398ZM12.7281 1.64834C12.7281 1.50056 12.7573 1.35423 12.8139 1.21771C12.8705 1.08119 12.9534 0.957157 13.058 0.852691C13.1625 0.748225 13.2866 0.665372 13.4231 0.608862C13.5597 0.552352 13.706 0.523293 13.8538 0.523342C14.0016 0.523391 14.1479 0.552548 14.2845 0.609149C14.421 0.66575 14.545 0.748686 14.6495 0.853222C14.7539 0.957757 14.8368 1.08185 14.8933 1.2184C14.9498 1.35496 14.9789 1.50131 14.9788 1.64909C14.9787 1.94756 14.8601 2.23376 14.649 2.44474C14.4378 2.65572 14.1516 2.77419 13.8531 2.77409C13.5546 2.77399 13.2684 2.65533 13.0574 2.44421C12.8465 2.23309 12.728 1.94681 12.7281 1.64834ZM17.9781 4.64834C17.978 4.94681 17.8593 5.23301 17.6482 5.44399C17.4371 5.65497 17.1508 5.77344 16.8523 5.77334C16.5539 5.77324 16.2677 5.65458 16.0567 5.44346C15.8457 5.23234 15.7272 4.94606 15.7273 4.64759C15.7274 4.34912 15.8461 4.06292 16.0572 3.85194C16.2683 3.64096 16.5546 3.52249 16.8531 3.52259C17.1516 3.52269 17.4378 3.64135 17.6487 3.85247C17.8597 4.06359 17.9782 4.34987 17.9781 4.64834ZM7.28083 12.7206C7.35047 12.7902 7.4057 12.8729 7.44339 12.9639C7.48107 13.0549 7.50047 13.1524 7.50047 13.2508C7.50047 13.3493 7.48107 13.4468 7.44339 13.5378C7.4057 13.6288 7.35047 13.7115 7.28083 13.7811C7.2112 13.8507 7.12853 13.906 7.03755 13.9436C6.94657 13.9813 6.84906 14.0007 6.75058 14.0007C6.65211 14.0007 6.55459 13.9813 6.46361 13.9436C6.37263 13.906 6.28997 13.8507 6.22033 13.7811L4.72033 12.2811C4.6507 12.2115 4.59546 12.1288 4.55778 12.0378C4.52009 11.9468 4.5007 11.8493 4.5007 11.7508C4.5007 11.6524 4.52009 11.5549 4.55778 11.4639C4.59546 11.3729 4.6507 11.2902 4.72033 11.2206C4.78997 11.151 4.87263 11.0957 4.96361 11.058C5.05459 11.0204 5.15211 11.001 5.25058 11.001C5.34906 11.001 5.44657 11.0204 5.53755 11.058C5.62853 11.0957 5.7112 11.151 5.78083 11.2206L7.28083 12.7206Z"
                        fill="#979699"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_114_6753">
                        <rect
                          width="18"
                          height="18"
                          fill="white"
                          transform="translate(0 0.5)"
                        />
                      </clipPath>
                    </defs>
                  </svg>{" "}
                  Musician: <span>Bianca</span>
                </p>
                <p>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="19"
                    viewBox="0 0 18 19"
                    fill="none"
                  >
                    <g clip-path="url(#clip0_114_6759)">
                      <path
                        d="M16.2872 14.2721C15.4282 15.3137 14.3038 16.1041 13.0329 16.5598C11.762 17.0156 10.3917 17.1198 9.06648 16.8615C7.74127 16.6032 6.51036 15.992 5.50365 15.0923C4.49693 14.1926 3.75175 13.0379 3.34673 11.7499H11.251C11.4499 11.7499 11.6407 11.6709 11.7813 11.5302C11.922 11.3896 12.001 11.1988 12.001 10.9999C12.001 10.801 11.922 10.6102 11.7813 10.4696C11.6407 10.3289 11.4499 10.2499 11.251 10.2499H3.03923C2.98822 9.75119 2.98822 9.24859 3.03923 8.74989H11.251C11.4499 8.74989 11.6407 8.67087 11.7813 8.53022C11.922 8.38957 12.001 8.1988 12.001 7.99989C12.001 7.80098 11.922 7.61021 11.7813 7.46956C11.6407 7.32891 11.4499 7.24989 11.251 7.24989H3.34673C3.75175 5.96193 4.49693 4.80718 5.50365 3.90751C6.51036 3.00783 7.74127 2.39659 9.06648 2.1383C10.3917 1.88 11.762 1.98422 13.0329 2.43996C14.3038 2.8957 15.4282 3.68607 16.2872 4.72764C16.4139 4.881 16.5964 4.97775 16.7944 4.9966C16.9925 5.01544 17.1899 4.95485 17.3432 4.82814C17.4966 4.70143 17.5933 4.51899 17.6122 4.32096C17.631 4.12292 17.5704 3.9255 17.4437 3.77214C16.3882 2.49286 14.9994 1.53043 13.431 0.991288C11.8626 0.452146 10.1756 0.3573 8.55658 0.717239C6.9376 1.07718 5.4497 1.87788 4.25744 3.03079C3.06519 4.18369 2.21503 5.64389 1.80098 7.24989H0.750977C0.552064 7.24989 0.361299 7.32891 0.220647 7.46956C0.0799942 7.61021 0.000976563 7.80098 0.000976562 7.99989C0.000976563 8.1988 0.0799942 8.38957 0.220647 8.53022C0.361299 8.67087 0.552064 8.74989 0.750977 8.74989H1.53923C1.51823 8.99814 1.50098 9.24639 1.50098 9.49989C1.50098 9.75339 1.51823 10.0016 1.53923 10.2499H0.750977C0.552064 10.2499 0.361299 10.3289 0.220647 10.4696C0.0799942 10.6102 0.000976563 10.801 0.000976562 10.9999C0.000976563 11.1988 0.0799942 11.3896 0.220647 11.5302C0.361299 11.6709 0.552064 11.7499 0.750977 11.7499H1.80098C2.21456 13.3567 3.06467 14.8178 4.25721 15.9714C5.44976 17.125 6.93825 17.9261 8.55792 18.2861C10.1776 18.6461 11.8653 18.551 13.4342 18.0112C15.0032 17.4714 16.3922 16.508 17.4475 15.2276C17.5742 15.0743 17.6348 14.8769 17.6159 14.6788C17.5971 14.4808 17.5003 14.2983 17.347 14.1716C17.1936 14.0449 16.9962 13.9843 16.7982 14.0032C16.6001 14.022 16.4177 14.1188 16.291 14.2721H16.2872Z"
                        fill="#979699"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_114_6759">
                        <rect
                          width="18"
                          height="18"
                          fill="white"
                          transform="translate(0 0.5)"
                        />
                      </clipPath>
                    </defs>
                  </svg>{" "}
                  Price: <span>€560.00</span>
                </p>
              </div>
              <div className="detail-pro-name event-details-text">
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                  Ut enim ad minim veniam, quis nostrud exercitation
                </p>
              </div>
              <div className="detail-pro-name">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <g opacity="0.8">
                    <path
                      d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
                      stroke="#132027"
                      stroke-width="2"
                      stroke-linecap="square"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z"
                      stroke="#132027"
                      stroke-width="2"
                      stroke-linecap="square"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z"
                      stroke="#132027"
                      stroke-width="2"
                      stroke-linecap="square"
                      stroke-linejoin="round"
                    />
                  </g>
                </svg>
              </div>
            </div>
          </Col>
          <Col lg={8}>
            <div className="comn-table-title">
              <h3>
                Song list <span>(12)</span>
              </h3>
              {/* <button onClick={handleShow}>Create Client</button> */}
            </div>
            <div className="filters">
              <div className="inner-filter-field">
                <div class="table-responsive">
                  <Table size="sm" className="table-cmn">
                    <thead>
                      <tr>
                        <th>
                          <div className="user-checkbox">Song name</div>
                        </th>
                        <th>Artist</th>
                        <th>Genre</th>
                        <th>Duration</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <div className="first-user">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="36"
                              height="36"
                              viewBox="0 0 36 36"
                              fill="none"
                            >
                              <path
                                d="M25 10.6667V25.3333C25 25.5986 24.8946 25.8529 24.7071 26.0404C24.5196 26.228 24.2652 26.3333 24 26.3333C23.7348 26.3333 23.4804 26.228 23.2929 26.0404C23.1054 25.8529 23 25.5986 23 25.3333V10.6667C23 10.4015 23.1054 10.1471 23.2929 9.95956C23.4804 9.77202 23.7348 9.66667 24 9.66667C24.2652 9.66667 24.5196 9.77202 24.7071 9.95956C24.8946 10.1471 25 10.4015 25 10.6667ZM20 6C19.7348 6 19.4804 6.10536 19.2929 6.29289C19.1054 6.48043 19 6.73478 19 7V29C19 29.2652 19.1054 29.5196 19.2929 29.7071C19.4804 29.8946 19.7348 30 20 30C20.2652 30 20.5196 29.8946 20.7071 29.7071C20.8946 29.5196 21 29.2652 21 29V7C21 6.73478 20.8946 6.48043 20.7071 6.29289C20.5196 6.10536 20.2652 6 20 6ZM28 13.3333C27.7348 13.3333 27.4804 13.4387 27.2929 13.6262C27.1054 13.8138 27 14.0681 27 14.3333V21C27 21.2652 27.1054 21.5196 27.2929 21.7071C27.4804 21.8946 27.7348 22 28 22C28.2652 22 28.5196 21.8946 28.7071 21.7071C28.8946 21.5196 29 21.2652 29 21V14.3333C29 14.0681 28.8946 13.8138 28.7071 13.6262C28.5196 13.4387 28.2652 13.3333 28 13.3333ZM16 10C15.7348 10 15.4804 10.1054 15.2929 10.2929C15.1054 10.4804 15 10.7348 15 11V25C15 25.2652 15.1054 25.5196 15.2929 25.7071C15.4804 25.8946 15.7348 26 16 26C16.2652 26 16.5196 25.8946 16.7071 25.7071C16.8946 25.5196 17 25.2652 17 25V11C17 10.7348 16.8946 10.4804 16.7071 10.2929C16.5196 10.1054 16.2652 10 16 10ZM12 13C11.7348 13 11.4804 13.1054 11.2929 13.2929C11.1054 13.4804 11 13.7348 11 14V22C11 22.2652 11.1054 22.5196 11.2929 22.7071C11.4804 22.8946 11.7348 23 12 23C12.2652 23 12.5196 22.8946 12.7071 22.7071C12.8946 22.5196 13 22.2652 13 22V14C13 13.7348 12.8946 13.4804 12.7071 13.2929C12.5196 13.1054 12.2652 13 12 13ZM8 15C7.73478 15 7.48043 15.1054 7.29289 15.2929C7.10536 15.4804 7 15.7348 7 16V20C7 20.2652 7.10536 20.5196 7.29289 20.7071C7.48043 20.8946 7.73478 21 8 21C8.26522 21 8.51957 20.8946 8.70711 20.7071C8.89464 20.5196 9 20.2652 9 20V16C9 15.7348 8.89464 15.4804 8.70711 15.2929C8.51957 15.1054 8.26522 15 8 15Z"
                                fill="#979699"
                              />
                            </svg>
                            <div className="user-profile">A Thousand Years</div>
                          </div>
                        </td>
                        <td>Christina Perri</td>
                        <td>Classical</td>
                        <td>3:50</td>
                      </tr>
                      <tr>
                        <td>
                          <div className="first-user">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="36"
                              height="36"
                              viewBox="0 0 36 36"
                              fill="none"
                            >
                              <path
                                d="M25 10.6667V25.3333C25 25.5986 24.8946 25.8529 24.7071 26.0404C24.5196 26.228 24.2652 26.3333 24 26.3333C23.7348 26.3333 23.4804 26.228 23.2929 26.0404C23.1054 25.8529 23 25.5986 23 25.3333V10.6667C23 10.4015 23.1054 10.1471 23.2929 9.95956C23.4804 9.77202 23.7348 9.66667 24 9.66667C24.2652 9.66667 24.5196 9.77202 24.7071 9.95956C24.8946 10.1471 25 10.4015 25 10.6667ZM20 6C19.7348 6 19.4804 6.10536 19.2929 6.29289C19.1054 6.48043 19 6.73478 19 7V29C19 29.2652 19.1054 29.5196 19.2929 29.7071C19.4804 29.8946 19.7348 30 20 30C20.2652 30 20.5196 29.8946 20.7071 29.7071C20.8946 29.5196 21 29.2652 21 29V7C21 6.73478 20.8946 6.48043 20.7071 6.29289C20.5196 6.10536 20.2652 6 20 6ZM28 13.3333C27.7348 13.3333 27.4804 13.4387 27.2929 13.6262C27.1054 13.8138 27 14.0681 27 14.3333V21C27 21.2652 27.1054 21.5196 27.2929 21.7071C27.4804 21.8946 27.7348 22 28 22C28.2652 22 28.5196 21.8946 28.7071 21.7071C28.8946 21.5196 29 21.2652 29 21V14.3333C29 14.0681 28.8946 13.8138 28.7071 13.6262C28.5196 13.4387 28.2652 13.3333 28 13.3333ZM16 10C15.7348 10 15.4804 10.1054 15.2929 10.2929C15.1054 10.4804 15 10.7348 15 11V25C15 25.2652 15.1054 25.5196 15.2929 25.7071C15.4804 25.8946 15.7348 26 16 26C16.2652 26 16.5196 25.8946 16.7071 25.7071C16.8946 25.5196 17 25.2652 17 25V11C17 10.7348 16.8946 10.4804 16.7071 10.2929C16.5196 10.1054 16.2652 10 16 10ZM12 13C11.7348 13 11.4804 13.1054 11.2929 13.2929C11.1054 13.4804 11 13.7348 11 14V22C11 22.2652 11.1054 22.5196 11.2929 22.7071C11.4804 22.8946 11.7348 23 12 23C12.2652 23 12.5196 22.8946 12.7071 22.7071C12.8946 22.5196 13 22.2652 13 22V14C13 13.7348 12.8946 13.4804 12.7071 13.2929C12.5196 13.1054 12.2652 13 12 13ZM8 15C7.73478 15 7.48043 15.1054 7.29289 15.2929C7.10536 15.4804 7 15.7348 7 16V20C7 20.2652 7.10536 20.5196 7.29289 20.7071C7.48043 20.8946 7.73478 21 8 21C8.26522 21 8.51957 20.8946 8.70711 20.7071C8.89464 20.5196 9 20.2652 9 20V16C9 15.7348 8.89464 15.4804 8.70711 15.2929C8.51957 15.1054 8.26522 15 8 15Z"
                                fill="#979699"
                              />
                            </svg>
                            <div className="user-profile">A Thousand Years</div>
                          </div>
                        </td>
                        <td>Christina Perri</td>
                        <td>Classical</td>
                        <td>3:50</td>
                      </tr>
                      <tr>
                        <td>
                          <div className="first-user">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="36"
                              height="36"
                              viewBox="0 0 36 36"
                              fill="none"
                            >
                              <path
                                d="M25 10.6667V25.3333C25 25.5986 24.8946 25.8529 24.7071 26.0404C24.5196 26.228 24.2652 26.3333 24 26.3333C23.7348 26.3333 23.4804 26.228 23.2929 26.0404C23.1054 25.8529 23 25.5986 23 25.3333V10.6667C23 10.4015 23.1054 10.1471 23.2929 9.95956C23.4804 9.77202 23.7348 9.66667 24 9.66667C24.2652 9.66667 24.5196 9.77202 24.7071 9.95956C24.8946 10.1471 25 10.4015 25 10.6667ZM20 6C19.7348 6 19.4804 6.10536 19.2929 6.29289C19.1054 6.48043 19 6.73478 19 7V29C19 29.2652 19.1054 29.5196 19.2929 29.7071C19.4804 29.8946 19.7348 30 20 30C20.2652 30 20.5196 29.8946 20.7071 29.7071C20.8946 29.5196 21 29.2652 21 29V7C21 6.73478 20.8946 6.48043 20.7071 6.29289C20.5196 6.10536 20.2652 6 20 6ZM28 13.3333C27.7348 13.3333 27.4804 13.4387 27.2929 13.6262C27.1054 13.8138 27 14.0681 27 14.3333V21C27 21.2652 27.1054 21.5196 27.2929 21.7071C27.4804 21.8946 27.7348 22 28 22C28.2652 22 28.5196 21.8946 28.7071 21.7071C28.8946 21.5196 29 21.2652 29 21V14.3333C29 14.0681 28.8946 13.8138 28.7071 13.6262C28.5196 13.4387 28.2652 13.3333 28 13.3333ZM16 10C15.7348 10 15.4804 10.1054 15.2929 10.2929C15.1054 10.4804 15 10.7348 15 11V25C15 25.2652 15.1054 25.5196 15.2929 25.7071C15.4804 25.8946 15.7348 26 16 26C16.2652 26 16.5196 25.8946 16.7071 25.7071C16.8946 25.5196 17 25.2652 17 25V11C17 10.7348 16.8946 10.4804 16.7071 10.2929C16.5196 10.1054 16.2652 10 16 10ZM12 13C11.7348 13 11.4804 13.1054 11.2929 13.2929C11.1054 13.4804 11 13.7348 11 14V22C11 22.2652 11.1054 22.5196 11.2929 22.7071C11.4804 22.8946 11.7348 23 12 23C12.2652 23 12.5196 22.8946 12.7071 22.7071C12.8946 22.5196 13 22.2652 13 22V14C13 13.7348 12.8946 13.4804 12.7071 13.2929C12.5196 13.1054 12.2652 13 12 13ZM8 15C7.73478 15 7.48043 15.1054 7.29289 15.2929C7.10536 15.4804 7 15.7348 7 16V20C7 20.2652 7.10536 20.5196 7.29289 20.7071C7.48043 20.8946 7.73478 21 8 21C8.26522 21 8.51957 20.8946 8.70711 20.7071C8.89464 20.5196 9 20.2652 9 20V16C9 15.7348 8.89464 15.4804 8.70711 15.2929C8.51957 15.1054 8.26522 15 8 15Z"
                                fill="#979699"
                              />
                            </svg>
                            <div className="user-profile">A Thousand Years</div>
                          </div>
                        </td>
                        <td>Christina Perri</td>
                        <td>Classical</td>
                        <td>3:50</td>
                      </tr>
                      <tr>
                        <td>
                          <div className="first-user">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="36"
                              height="36"
                              viewBox="0 0 36 36"
                              fill="none"
                            >
                              <path
                                d="M25 10.6667V25.3333C25 25.5986 24.8946 25.8529 24.7071 26.0404C24.5196 26.228 24.2652 26.3333 24 26.3333C23.7348 26.3333 23.4804 26.228 23.2929 26.0404C23.1054 25.8529 23 25.5986 23 25.3333V10.6667C23 10.4015 23.1054 10.1471 23.2929 9.95956C23.4804 9.77202 23.7348 9.66667 24 9.66667C24.2652 9.66667 24.5196 9.77202 24.7071 9.95956C24.8946 10.1471 25 10.4015 25 10.6667ZM20 6C19.7348 6 19.4804 6.10536 19.2929 6.29289C19.1054 6.48043 19 6.73478 19 7V29C19 29.2652 19.1054 29.5196 19.2929 29.7071C19.4804 29.8946 19.7348 30 20 30C20.2652 30 20.5196 29.8946 20.7071 29.7071C20.8946 29.5196 21 29.2652 21 29V7C21 6.73478 20.8946 6.48043 20.7071 6.29289C20.5196 6.10536 20.2652 6 20 6ZM28 13.3333C27.7348 13.3333 27.4804 13.4387 27.2929 13.6262C27.1054 13.8138 27 14.0681 27 14.3333V21C27 21.2652 27.1054 21.5196 27.2929 21.7071C27.4804 21.8946 27.7348 22 28 22C28.2652 22 28.5196 21.8946 28.7071 21.7071C28.8946 21.5196 29 21.2652 29 21V14.3333C29 14.0681 28.8946 13.8138 28.7071 13.6262C28.5196 13.4387 28.2652 13.3333 28 13.3333ZM16 10C15.7348 10 15.4804 10.1054 15.2929 10.2929C15.1054 10.4804 15 10.7348 15 11V25C15 25.2652 15.1054 25.5196 15.2929 25.7071C15.4804 25.8946 15.7348 26 16 26C16.2652 26 16.5196 25.8946 16.7071 25.7071C16.8946 25.5196 17 25.2652 17 25V11C17 10.7348 16.8946 10.4804 16.7071 10.2929C16.5196 10.1054 16.2652 10 16 10ZM12 13C11.7348 13 11.4804 13.1054 11.2929 13.2929C11.1054 13.4804 11 13.7348 11 14V22C11 22.2652 11.1054 22.5196 11.2929 22.7071C11.4804 22.8946 11.7348 23 12 23C12.2652 23 12.5196 22.8946 12.7071 22.7071C12.8946 22.5196 13 22.2652 13 22V14C13 13.7348 12.8946 13.4804 12.7071 13.2929C12.5196 13.1054 12.2652 13 12 13ZM8 15C7.73478 15 7.48043 15.1054 7.29289 15.2929C7.10536 15.4804 7 15.7348 7 16V20C7 20.2652 7.10536 20.5196 7.29289 20.7071C7.48043 20.8946 7.73478 21 8 21C8.26522 21 8.51957 20.8946 8.70711 20.7071C8.89464 20.5196 9 20.2652 9 20V16C9 15.7348 8.89464 15.4804 8.70711 15.2929C8.51957 15.1054 8.26522 15 8 15Z"
                                fill="#979699"
                              />
                            </svg>
                            <div className="user-profile">A Thousand Years</div>
                          </div>
                        </td>
                        <td>Christina Perri</td>
                        <td>Classical</td>
                        <td>3:50</td>
                      </tr>
                      <tr>
                        <td>
                          <div className="first-user">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="36"
                              height="36"
                              viewBox="0 0 36 36"
                              fill="none"
                            >
                              <path
                                d="M25 10.6667V25.3333C25 25.5986 24.8946 25.8529 24.7071 26.0404C24.5196 26.228 24.2652 26.3333 24 26.3333C23.7348 26.3333 23.4804 26.228 23.2929 26.0404C23.1054 25.8529 23 25.5986 23 25.3333V10.6667C23 10.4015 23.1054 10.1471 23.2929 9.95956C23.4804 9.77202 23.7348 9.66667 24 9.66667C24.2652 9.66667 24.5196 9.77202 24.7071 9.95956C24.8946 10.1471 25 10.4015 25 10.6667ZM20 6C19.7348 6 19.4804 6.10536 19.2929 6.29289C19.1054 6.48043 19 6.73478 19 7V29C19 29.2652 19.1054 29.5196 19.2929 29.7071C19.4804 29.8946 19.7348 30 20 30C20.2652 30 20.5196 29.8946 20.7071 29.7071C20.8946 29.5196 21 29.2652 21 29V7C21 6.73478 20.8946 6.48043 20.7071 6.29289C20.5196 6.10536 20.2652 6 20 6ZM28 13.3333C27.7348 13.3333 27.4804 13.4387 27.2929 13.6262C27.1054 13.8138 27 14.0681 27 14.3333V21C27 21.2652 27.1054 21.5196 27.2929 21.7071C27.4804 21.8946 27.7348 22 28 22C28.2652 22 28.5196 21.8946 28.7071 21.7071C28.8946 21.5196 29 21.2652 29 21V14.3333C29 14.0681 28.8946 13.8138 28.7071 13.6262C28.5196 13.4387 28.2652 13.3333 28 13.3333ZM16 10C15.7348 10 15.4804 10.1054 15.2929 10.2929C15.1054 10.4804 15 10.7348 15 11V25C15 25.2652 15.1054 25.5196 15.2929 25.7071C15.4804 25.8946 15.7348 26 16 26C16.2652 26 16.5196 25.8946 16.7071 25.7071C16.8946 25.5196 17 25.2652 17 25V11C17 10.7348 16.8946 10.4804 16.7071 10.2929C16.5196 10.1054 16.2652 10 16 10ZM12 13C11.7348 13 11.4804 13.1054 11.2929 13.2929C11.1054 13.4804 11 13.7348 11 14V22C11 22.2652 11.1054 22.5196 11.2929 22.7071C11.4804 22.8946 11.7348 23 12 23C12.2652 23 12.5196 22.8946 12.7071 22.7071C12.8946 22.5196 13 22.2652 13 22V14C13 13.7348 12.8946 13.4804 12.7071 13.2929C12.5196 13.1054 12.2652 13 12 13ZM8 15C7.73478 15 7.48043 15.1054 7.29289 15.2929C7.10536 15.4804 7 15.7348 7 16V20C7 20.2652 7.10536 20.5196 7.29289 20.7071C7.48043 20.8946 7.73478 21 8 21C8.26522 21 8.51957 20.8946 8.70711 20.7071C8.89464 20.5196 9 20.2652 9 20V16C9 15.7348 8.89464 15.4804 8.70711 15.2929C8.51957 15.1054 8.26522 15 8 15Z"
                                fill="#979699"
                              />
                            </svg>
                            <div className="user-profile">A Thousand Years</div>
                          </div>
                        </td>
                        <td>Christina Perri</td>
                        <td>Classical</td>
                        <td>3:50</td>
                      </tr>
                      <tr>
                        <td>
                          <div className="first-user">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="36"
                              height="36"
                              viewBox="0 0 36 36"
                              fill="none"
                            >
                              <path
                                d="M25 10.6667V25.3333C25 25.5986 24.8946 25.8529 24.7071 26.0404C24.5196 26.228 24.2652 26.3333 24 26.3333C23.7348 26.3333 23.4804 26.228 23.2929 26.0404C23.1054 25.8529 23 25.5986 23 25.3333V10.6667C23 10.4015 23.1054 10.1471 23.2929 9.95956C23.4804 9.77202 23.7348 9.66667 24 9.66667C24.2652 9.66667 24.5196 9.77202 24.7071 9.95956C24.8946 10.1471 25 10.4015 25 10.6667ZM20 6C19.7348 6 19.4804 6.10536 19.2929 6.29289C19.1054 6.48043 19 6.73478 19 7V29C19 29.2652 19.1054 29.5196 19.2929 29.7071C19.4804 29.8946 19.7348 30 20 30C20.2652 30 20.5196 29.8946 20.7071 29.7071C20.8946 29.5196 21 29.2652 21 29V7C21 6.73478 20.8946 6.48043 20.7071 6.29289C20.5196 6.10536 20.2652 6 20 6ZM28 13.3333C27.7348 13.3333 27.4804 13.4387 27.2929 13.6262C27.1054 13.8138 27 14.0681 27 14.3333V21C27 21.2652 27.1054 21.5196 27.2929 21.7071C27.4804 21.8946 27.7348 22 28 22C28.2652 22 28.5196 21.8946 28.7071 21.7071C28.8946 21.5196 29 21.2652 29 21V14.3333C29 14.0681 28.8946 13.8138 28.7071 13.6262C28.5196 13.4387 28.2652 13.3333 28 13.3333ZM16 10C15.7348 10 15.4804 10.1054 15.2929 10.2929C15.1054 10.4804 15 10.7348 15 11V25C15 25.2652 15.1054 25.5196 15.2929 25.7071C15.4804 25.8946 15.7348 26 16 26C16.2652 26 16.5196 25.8946 16.7071 25.7071C16.8946 25.5196 17 25.2652 17 25V11C17 10.7348 16.8946 10.4804 16.7071 10.2929C16.5196 10.1054 16.2652 10 16 10ZM12 13C11.7348 13 11.4804 13.1054 11.2929 13.2929C11.1054 13.4804 11 13.7348 11 14V22C11 22.2652 11.1054 22.5196 11.2929 22.7071C11.4804 22.8946 11.7348 23 12 23C12.2652 23 12.5196 22.8946 12.7071 22.7071C12.8946 22.5196 13 22.2652 13 22V14C13 13.7348 12.8946 13.4804 12.7071 13.2929C12.5196 13.1054 12.2652 13 12 13ZM8 15C7.73478 15 7.48043 15.1054 7.29289 15.2929C7.10536 15.4804 7 15.7348 7 16V20C7 20.2652 7.10536 20.5196 7.29289 20.7071C7.48043 20.8946 7.73478 21 8 21C8.26522 21 8.51957 20.8946 8.70711 20.7071C8.89464 20.5196 9 20.2652 9 20V16C9 15.7348 8.89464 15.4804 8.70711 15.2929C8.51957 15.1054 8.26522 15 8 15Z"
                                fill="#979699"
                              />
                            </svg>
                            <div className="user-profile">A Thousand Years</div>
                          </div>
                        </td>
                        <td>Christina Perri</td>
                        <td>Classical</td>
                        <td>3:50</td>
                      </tr>
                    </tbody>
                  </Table>
                  <div className="pagination-section">
                    <div className="showing-user">
                      <p>Showing 1 to 10 of 50 entries</p>
                    </div>
                    <div className="pagination-block">
                      <Pagination>
                        {/* <Pagination.First /> */}
                        <Pagination.Prev />
                        <Pagination.Item>{1}</Pagination.Item>
                        <Pagination.Item>{2}</Pagination.Item>
                        <Pagination.Item active>{3}</Pagination.Item>
                        <Pagination.Item>{4}</Pagination.Item>
                        <Pagination.Next />
                        {/* <Pagination.Last /> */}
                      </Pagination>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Col>
          <Col lg={4}>
            <div className="comn-table-title">
              <h3>Payment history</h3>
              {/* <button onClick={handleShow}>Create Client</button> */}
            </div>
            <div className="filters">
              <div className="inner-filter-field">
                <div class="table-responsive">
                  <Table size="sm" className="table-cmn">
                    <thead>
                      <tr>
                        <th>
                          <div className="user-checkbox">Date</div>
                        </th>
                        <th>Amount</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <div className="first-user">
                            <div className="user-profile">Nov 30, 2024</div>
                          </div>
                        </td>
                        <td>€800</td>
                        <td>Paid</td>
                      </tr>
                      <tr>
                        <td>
                          <div className="first-user">
                            <div className="user-profile">Nov 30, 2024</div>
                          </div>
                        </td>
                        <td>€800</td>
                        <td>Paid</td>
                      </tr>
                      <tr>
                        <td>
                          <div className="first-user">
                            <div className="user-profile">Nov 30, 2024</div>
                          </div>
                        </td>
                        <td>€800</td>
                        <td>Paid</td>
                      </tr>
                      <tr>
                        <td>
                          <div className="first-user">
                            <div className="user-profile">Nov 30, 2024</div>
                          </div>
                        </td>
                        <td>€800</td>
                        <td>Paid</td>
                      </tr>
                      <tr>
                        <td>
                          <div className="first-user">
                            <div className="user-profile">Nov 30, 2024</div>
                          </div>
                        </td>
                        <td>€800</td>
                        <td>Paid</td>
                      </tr>
                      <tr>
                        <td>
                          <div className="first-user">
                            <div className="user-profile">Nov 30, 2024</div>
                          </div>
                        </td>
                        <td>€800</td>
                        <td>Paid</td>
                      </tr>
                      <tr>
                        <td>
                          <div className="first-user">
                            <div className="user-profile">Nov 30, 2024</div>
                          </div>
                        </td>
                        <td>€800</td>
                        <td>Paid</td>
                      </tr>
                      <tr>
                        <td>
                          <div className="first-user">
                            <div className="user-profile">Nov 30, 2024</div>
                          </div>
                        </td>
                        <td>€800</td>
                        <td>Paid</td>
                      </tr>
                      <tr>
                        <td>
                          <div className="first-user">
                            <div className="user-profile">Nov 30, 2024</div>
                          </div>
                        </td>
                        <td>€800</td>
                        <td>Paid</td>
                      </tr>
                    </tbody>
                  </Table>
                  {/* <div className="pagination-section">
                    <div className="showing-user">
                      <p>Showing 1 to 10 of 50 entries</p>
                    </div>
                    <div className="pagination-block">
                      <Pagination>
                        <Pagination.First />
                        <Pagination.Prev />
                        <Pagination.Item>{1}</Pagination.Item>
                        <Pagination.Item>{2}</Pagination.Item>
                        <Pagination.Item active>{3}</Pagination.Item>
                        <Pagination.Item>{4}</Pagination.Item>
                        <Pagination.Next />
                        <Pagination.Last />
                      </Pagination>
                    </div>
                  </div> */}
                </div>
              </div>
            </div>
          </Col>
        </Row>
        <div className="pb-4">
          <p className="mt-0"></p>
        </div>
      </Container>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header className="border-none justify-content-center">
          <Modal.Title className="mt-3">Create Client</Modal.Title>
        </Modal.Header>
        <Modal.Body className="py-0">
          <div>
            <Form>
              <div className="modal-cmn-form-set">
                <Form.Group className="mb-3" controlId="formBasicEmail">
                  <Form.Label>Full Name*</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter your Full Name"
                  />
                </Form.Group>
                <Form.Group className="mb-3" controlId="formBasicEmail">
                  <Form.Label>Email ID*</Form.Label>
                  <Form.Control type="email" placeholder="Enter your email " />
                </Form.Group>
                <Form.Group className="mb-3" controlId="formBasicEmail">
                  <Form.Label>Estimated Date</Form.Label>
                  <Form.Control type="date" placeholder="Select date" />
                </Form.Group>
                <Form.Group className="mb-3" controlId="formBasicEmail">
                  <Form.Label>Notes</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    placeholder="Lorem ipsum dolor sit"
                  />
                </Form.Group>
              </div>
            </Form>
          </div>
        </Modal.Body>
        <Modal.Footer className="border-none justify-content-center">
          <button className="secondary" onClick={handleClose}>
            Close
          </button>
          <button className="primary" onClick={handleClose}>
            Create
          </button>
        </Modal.Footer>
      </Modal>
    </Layout>
  );
}
